import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetServiceAccountQuery } from "../../store/api/serviceAccountApi";
import { ServiceAccountDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "serviceaccount";
export const ServiceAccountDetailInitializer: React.FC = () => {
  const { org: orgName, serviceaccount: serviceAccountName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/serviceaccount/${serviceAccountName}`;

  const { data: serviceAccount, isLoading, isFetching, isError, error, refetch } = useGetServiceAccountQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!serviceAccount && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="serviceaccount" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !serviceAccount) {
    return <IncorrectItem kind="serviceaccount" canCreate={true} />;
  }

  return <ServiceAccountDetailForm serviceAccount={serviceAccount} />;
};
